import { useSelector } from 'react-redux';
import { makeGetProductDefaults } from '../../redux/product/selectors/ProductSelector';
import { useFeefoWidget } from '../../hooks/useFeefoWidget';
export const UserReviews = () => {
    const { productCode } = useSelector(makeGetProductDefaults());
    const { renderFeefoWidget } = useFeefoWidget(productCode, !!productCode);
    return renderFeefoWidget();
};
